import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Route guard that blocks PARTNER users from pages they shouldn't reach by URL.
 * The menu link is already hidden for them (Sidebar checks user.role !== 'PARTNER'),
 * but a Partner who pastes /datacentres or similar would otherwise load the page.
 * Redirects them back to /stores instead.
 */
export const NonPartnerRoute = () => {
  const user = useSelector((state) => state.user);
  const isPartner = user.selected && user.selected.role === 'PARTNER';
  return isPartner ? <Navigate to="/stores" replace /> : <Outlet />;
};
